import { com } from '../generated/proto-generated';
import { removeTrailingSlashes } from '../utils/locationUtils';
import { merge } from 'lodash';
import { INTERNAL_DOMAIN } from '../server/middlewares/boAuthMiddleware';
import cloneDeep from 'lodash/cloneDeep';

export class ViewerWrapper extends com.wixpress.wixdocs.Viewer {
  baseDomain: string | undefined;

  constructor(viewerObject = {}) {
    const mergedViewerObject = merge(
      {
        id: 'VIEWER_ID',
        projectId: 'PROJECT_ID',
        currentVersion: '1.0.0',
        baseDomain: 'https://bo.wix.com/wix-docs',
        viewerConfig: {
          layoutType: com.wixpress.wixdocs.ViewerConfig.LayoutType.REST,
          relatedSites: [],
          seoConfig: {
            pageTitleSuffix: '| Wix.com',
            hideFromSearchEngines: false,
            homePageDescription: '',
            homePageTitle: 'API Reference',
          },
          displayOptions: {
            showComplexTypesInTable: false,
            openAllExamplesOnStart: false,
            hideRestPlayground: false,
            showTokenBar: false,
            favicon: 'https://www.wix.com/favicon.ico',
            showSourceLink: false,
          },
          embeddedScripts: [],
          githubSourceUrl: '',
          customLabelsTemplates: {},
          resolvingNameConflicts: {},
          urlPath: '/rest',
          host: 'bo.wix.com',
          basename: 'wix-docs',
        },
        artifactId: '',
        menuConfig: {
          categories: [],
        },
      },
      { ...viewerObject },
    );
    super(mergedViewerObject);
    this.baseDomain = mergedViewerObject.baseDomain;
    delete this.emailList;
    delete this.availableVersions;
    delete this.latestVersion;
    return this;
  }

  getViewerPath(): string {
    const urlPath = this.viewerConfig?.urlPath;
    return removeTrailingSlashes(`${this.baseDomain}${urlPath}`);
  }

  isInternalViewer(): boolean {
    return this.baseDomain.startsWith(INTERNAL_DOMAIN);
  }

  updateViewerVersion(nextViewerVersion) {
    this.currentVersion = nextViewerVersion;
  }

  toObject() {
    return cloneDeep({
      ...this,
      getViewerPath: undefined,
      isInternalViewer: undefined,
      updateViewerVersion: undefined,
      toObject: undefined,
      availableVersions: undefined,
      latestVersion: undefined,
    });
  }
}
